import { parseJsonSafe } from '../../utils/json/parseJsonSafe';

export const getSessionTeamType = () => parseJsonSafe(sessionStorage.getItem('TEAM_TYPE'));
